import { ApplicationRef, ComponentRef, EnvironmentInjector, Injectable, Type, createComponent } from '@angular/core';
import { Dialog } from './dialog';

@Injectable({providedIn: 'root'})
export class DialogService {
  constructor(private readonly appRef: ApplicationRef, private readonly injector: EnvironmentInjector) { }

  public create<T extends Dialog>(component: Type<T>, params: Partial<T> | null = null): T {
    // see https://angular.io/guide/elements#example-a-popup-service
    const element: HTMLElement = document.createElement('div');

    const componentRef: ComponentRef<T> = createComponent(component, { environmentInjector: this.injector, hostElement: element });
    const instance: T = componentRef.instance;

    if (params !== null) {
      for (const key in params) {
        instance[key] = params[key]!;
      }
    }

    this.appRef.attachView(componentRef.hostView);

    instance.closed.subscribe(() => {
      componentRef.destroy();
    });

    document.body.appendChild(element);

    return instance;
  }
}
